"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _utils = require("@insided/destination/modules/Content/TopicView/utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ExtraMenu = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ExtraMenu, _Component);

  var _super = _createSuper(ExtraMenu);

  function ExtraMenu() {
    var _this;

    (0, _classCallCheck2.default)(this, ExtraMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isExtraMenuOpen: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "extraTimeout", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onExtraEnter", function () {
      if (_this.extraTimeout) clearTimeout(_this.extraTimeout);

      _this.setState({
        isExtraMenuOpen: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onExtraLeave", function () {
      _this.extraTimeout = setTimeout(function () {
        return _this.setState({
          isExtraMenuOpen: false
        });
      }, 300);
    });
    return _this;
  }

  (0, _createClass2.default)(ExtraMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          showEdit = _this$props.showEdit,
          postId = _this$props.postId,
          onEditClick = _this$props.onEditClick,
          showReport = _this$props.showReport,
          onReportClick = _this$props.onReportClick;
      var isExtraMenuOpen = this.state.isExtraMenuOpen;
      return (0, _preact.h)("li", {
        className: (0, _classnames.default)('tooltip', 'tooltip--day', 'post__action-item', 'post__action-item--more'),
        onMouseEnter: this.onExtraEnter,
        onMouseLeave: this.onExtraLeave
      }, (0, _preact.h)(_phrase.default, {
        p: "accessibility_label.show_additional_post_actions",
        renderAsText: true
      }, function (accessibilityLabel) {
        return (0, _preact.h)(_Button.default, {
          className: (0, _classnames.default)('post__action-link', 'tooltip-trigger', 'js-tooltip-trigger'),
          onKeyDown: function onKeyDown(e) {
            return (e.key === 'Enter' || e.key === 'Space') && _this2.onExtraEnter();
          },
          "aria-label": accessibilityLabel
        }, (0, _preact.h)("span", {
          className: (0, _classnames.default)('icon--auto-width', 'icon--ellipsis', 'qa-topic-post-ellipsis')
        }));
      }), isExtraMenuOpen ? (0, _preact.h)("ul", {
        className: (0, _classnames.default)('list', 'tooltip__content', 'tooltip__content--more position--bottom-right', 'is-enabled', 'is-active')
      }, (0, _preact.h)("i", {
        className: "arrow"
      }), showEdit ? (0, _preact.h)("li", {
        className: "more__item post__action-dropdown-item"
      }, (0, _preact.h)("a", {
        className: (0, _classnames.default)('link', 'js-edit', 'qa-topic-post-edit', 'post__action-dropdown-link'),
        href: (0, _absoluteUrlRuntime.resolveUrl)("/post/edit?postid=".concat(postId)),
        "data-postid": postId,
        onClick: onEditClick
      }, (0, _preact.h)(_phrase.default, {
        p: "Edit"
      }))) : null, (0, _preact.h)("li", {
        className: "more__item post__action-dropdown-item"
      }, (0, _preact.h)("a", {
        className: (0, _classnames.default)('link', 'qa-topic-post-permalink', 'post__action-dropdown-link'),
        href: (0, _absoluteUrlRuntime.resolveUrl)((0, _utils.getPermalink)(postId))
      }, (0, _preact.h)(_phrase.default, {
        p: "Permalink"
      }))), showReport ? (0, _preact.h)("li", {
        className: "more__item post__action-dropdown-item"
      }, (0, _preact.h)("a", {
        className: (0, _classnames.default)('link', 'qa-topic-post-report', 'post__action-dropdown-link'),
        onClick: onReportClick,
        role: "button",
        tabIndex: 0,
        "aria-label": "Report",
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter') {
            onReportClick(e);
          }
        }
      }, (0, _preact.h)(_phrase.default, {
        p: "topic_view.reported_content_option.report"
      }))) : null) : null);
    }
  }]);
  return ExtraMenu;
}(_preact.Component);

var _default = ExtraMenu;
exports.default = _default;